import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async CreateAds(token, g_ads_id, fb_id) {
    return api.post(
      `/v1/ads/create`,
      { g_ads_id, fb_id },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
